import React from "react";
import TextField from "@mui/material/TextField";

/**
 * Native date/time inputs always render browser-provided format segments, even
 * when their value is empty. Keep the field label above those segments so the
 * two never overlap.
 */
export default function DateTimeField({ slotProps, type = "date", ...props }) {
  return (
    <TextField
      {...props}
      type={type}
      slotProps={{
        ...slotProps,
        inputLabel: {
          ...slotProps?.inputLabel,
          shrink: true,
        },
      }}
    />
  );
}
